import { Target, Eye } from "lucide-react";
import workshopImageAvif640 from "@/assets/why-us-workshop-640.avif";
import workshopImageAvif1280 from "@/assets/why-us-workshop-1280.avif";
import workshopImageAvif1920 from "@/assets/why-us-workshop-1920.avif";
import workshopImageJpg640 from "@/assets/why-us-workshop-640.jpg";
import workshopImageJpg1280 from "@/assets/why-us-workshop-1280.jpg";
import workshopImageJpg1920 from "@/assets/why-us-workshop-1920.jpg";
import { useLanguage } from "@/i18n/LanguageContext";

const WhyUsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="why-us" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block text-accent font-semibold mb-4 uppercase tracking-wider text-sm">{t("whyus.label")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">{t("whyus.title")}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <picture>
                <source type="image/avif"
                  srcSet={`
                    ${workshopImageAvif640} 640w,
                    ${workshopImageAvif1280} 1280w,
                    ${workshopImageAvif1920} 1920w
                  `}
                  sizes="(max-width: 1024px) 100vw, 50vw" />

                <source
                  type="image/jpeg"
                  srcSet={`
                    ${workshopImageJpg640} 640w,
                    ${workshopImageJpg1280} 1280w,
                    ${workshopImageJpg1920} 1920w
                  `}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />

                <img
                  src={workshopImageJpg1280}
                  alt="Warsztat Gendera Service"
                  className="w-full h-full object-cover"
                  width={1200}
                  height={900}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  loading="lazy"
                  decoding="async" />
              </picture>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-secondary rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Target className="w-7 h-7 text-accent" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3">{t("whyus.goals.title")}</h3>
                  <p className="text-muted-foreground leading-relaxed">{t("whyus.goals.desc")}</p>
                </div>
              </div>
            </div>

            <div className="bg-secondary rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Eye className="w-7 h-7 text-accent" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3">{t("whyus.vision.title")}</h3>
                  <p className="text-muted-foreground leading-relaxed">{t("whyus.vision.desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
